import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: true,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en: {
        translation: {
          mainnet: "Mainnet",
          networth:"Net Worth",
          performance: "Performance",
          dashboard: "Dashboard",
          dex: "Trade",
          swap:"Swap",
          history:"History",
          back: "<- Back",
          chart:"Chart",
          chart7d:"Chart (7D)",
          info:'Info',
          rank:"Rank",
          marketcap: "Market Cap",
          circulatingsupply: "Circulating Supply",
          twitter:"Twitter",
          indices: "Indices",
          from: "From",
          to:"To",
          balance: "Balance",
          swap_large: "SWAP",
          transactionSettings: "Transaction Settings",
          slippageTolerance: "Slippage Tolerance",
          minimumReceived: "Minimum Received",
          transactionFee: "Swap Fee",
          symmetryFee: "Symmetry Fee",
          whatIs: "What is ",
          connectWallet: "Connect Wallet",
          chooseAsset: "Choose Asset",
          approveTx: "Please approve transaction",
          notSeenTx: "Transaction not generated",
          failedTx: "Transaction Failed",
          generatingTx: "Generating Transaction",
          finalizingTx: "Finalizing Transaction",
          confirmingTx: "Confirming Transaction",
          txFinalizing: "Transaction(s) are finalizing.",
          netWorthRank: "Rank",
          allocation: "Allocation",
          "24h":"24H",
          "7d":"1W",
          "30d":"1M",
          "0.5":"0.5%",
          "1":"1%",
          "3":"3%",
          "5": "5%",
          "10":"10%",
          assets:"Assets",
          indices:"Indices",
          timeframe: "Timeframe",
          pnl: "Profit & Loss",
          walletempty:"Wallet is Empty",
          depositFtx: "Deposit crypto with a Credit Card",
          alternativeDeposit: "You can also deposit SOL or any SPL token at:",
          share:"Share",
          allocations: "Allocations",
          buy: "BUY",
          withcc: "with Credit Card",
          poweredbyftxpay: "Powered by FTX Pay",
          feedback: "Feedback",
          portfolio:"Portfolio",
          viewOnExplorer:"View on Solscan",
          transactionComplete: "Transaction Complete",
          highSlippage: "WARNING: High Slippage!",
          amountTooLow: "Swap amount too low",
          insufficientBalance: "Insufficient balance",
          finalizedTx: "Finalized",
          show: "Show",
          hide: "Hide",
          priceCharts: "Price Charts",
          custom: "Custom",
          slippageErrorTx: "Slippage exceeded, Aborting ..."
        }
      },
      nl: {
       translation: {
        mainnet: "Hoofdnet",
        networth:"Totale waarde",
        performance: "Prestatie",
        dashboard: "Dashboard",
        dex: "Ruilen",
        swap:"Omwisselen",
        history:"Geschiedenis",
        back: "<- Terug",
        chart:"Grafiek",
        chart7d:"Grafiek (7D)",
        info:'Informatie',
        rank:"Rang",
        marketcap: "Markt Waarde",
        circulatingsupply: "Omgaande Voorraad",
        twitter:"Twitter",
        indices: "Indexen",
        from: "Van",
        to:"Naar",
        balance: "Balans",
        swap_large: "OMWISSELEN",
        transactionSettings: "Transactie Instellingen",
        slippageTolerance: "Sliptolerantie",
        minimumReceived: "Minimum Ontvangen",
        transactionFee: "Geschatte Transactiekosten",
        symmetryFee: "Symmetry Vergoeding",
        whatIs: "Wat is ",
        connectWallet: "Verbindt Portefeuille",
        chooseAsset: "Kies Aanwinst"
       }
      }
    }
  });

export default i18n;
